import { render, staticRenderFns } from "./coefficients.pug?vue&type=template&id=c990189c&lang=pug&"
import script from "./coefficients.js?vue&type=script&lang=js&"
export * from "./coefficients.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c990189c')) {
      api.createRecord('c990189c', component.options)
    } else {
      api.reload('c990189c', component.options)
    }
    module.hot.accept("./coefficients.pug?vue&type=template&id=c990189c&lang=pug&", function () {
      api.rerender('c990189c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminLayout/views/coefficients/index.vue"
export default component.exports